export interface SellingUnitConversion {
  sellingUnitOfMeasureId: string;
  orderUnitOfMeasureId: string;
  orderUnitOfMeasureShortDescription: string;
  orderUnitOfMeasureDescription: string;
  conversionQuantity: number;
}
